import React from "react";
import "./components.css";

export default ({ handler, disabled = [] }) => {
  const Button = ({ name, text }) => {
    const isDisabled = disabled.includes(name);
    return (
      <button className={`btn ${name}`} disabled={isDisabled} onClick={e => handler(name)}>
        {text}
      </button>
    );
  };

  return (
    <div className="button-bar">
      <Button name="new" text="New Game" />
      <Button name="question" text="Question" />
      <Button name="answer" text="Answer" />
      <Button name="correct_10" text="Correct: +10" />
      <Button name="correct_5" text="Correct: +5" />
      <Button name="clear" text="Clear" />
      <Button name="scoreboard" text="Show Scores" />
      <Button name="next" text="Next Question" />
    </div>
  );
};
